// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"K7z8LYQb","content":"FjYi5wIe","close":"rdjfNJCL","container":"RQm3Gcq2","dot":"dX6YlhnZ","fadeOut":"V35dNx3X","globalTooltip":"PeNt7deH"};